export default "__VITE_ASSET__CUcBtAWx__"